// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/banner-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/images/apia_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redeem-page-wrapper {
  background-color: #ffffff;
  min-height: 100vh;
}
.redeem-page-wrapper .redeem-header {
  display: flex;
  flex-direction: row;
  padding-top: 16px;
  padding-bottom: 16px;
  align-items: center;
}
.redeem-page-wrapper .redeem-header img {
  width: 300px;
  max-width: 100%;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-header img {
    width: 225px;
  }
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-header {
    padding-top: 12px;
    padding-bottom: 12px;
    justify-content: center;
  }
}
.redeem-page-wrapper .apia-text-color {
  color: #00369c;
}
.redeem-page-wrapper .apia-button-color input[type=submit] {
  background-color: #00837c;
  color: #fff;
}
.redeem-page-wrapper .suncorp-button-color input[type=submit] {
  background-color: #fab919;
  color: black;
}
.redeem-page-wrapper .greeting-message {
  background-color: #f5f5f5;
}
.redeem-page-wrapper .greeting-message .greeting-message-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 0 50%;
  padding-top: 37px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .greeting-message .greeting-message-content {
    background-image: none;
    flex-direction: column-reverse;
    padding-top: 18px;
    padding-bottom: 25px;
  }
}
.redeem-page-wrapper .greeting-message .greeting-message-text {
  font-size: 2.8rem;
  line-height: 1.5;
  font-weight: 700;
  line-height: 54.28px;
  color: #2a2a2a;
  width: 60%;
  max-width: 640px;
  padding: 30px 0;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .greeting-message .greeting-message-text {
    padding: 13px 0 30px;
    font-size: 2rem;
    line-height: 1.2;
    width: 100%;
  }
}
@media (max-width: 767px) {
  .redeem-page-wrapper .greeting-message .greeting-message-image {
    text-align: center;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .redeem-page-wrapper .greeting-message .greeting-message-image img {
    width: 210px;
  }
}
.redeem-page-wrapper {
  /*************
  REDEEM STEPS
  **************/
}
.redeem-page-wrapper .redeem-steps-wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-steps-wrapper {
    padding-top: 34px;
  }
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-step-text {
  display: flex;
  font-size: 2rem;
  color: #cc0000;
  justify-content: center;
  align-items: center;
  font-weight: 650;
  margin-bottom: 29px;
  text-align: center;
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 8px;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-steps-wrapper .redeem-steps {
    flex-direction: column;
  }
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps {
  /** redeem step count **/
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 280px;
  padding: 0 16px 32px;
  text-align: center;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count {
    width: 100%;
    max-width: none;
  }
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count .redeem-circle {
  text-align: center;
  margin-bottom: 24px;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count .redeem-circle {
    margin-bottom: 17px;
  }
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count .redeem-circle img {
  margin: 0 auto;
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-steps .redeem-steps-count .redeem-circle-text p {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #2a2a2a;
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-step-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
}
.redeem-page-wrapper .redeem-steps-wrapper .redeem-step-bottom .redeem-step-bottom-text {
  font-size: 11.32px;
  font-weight: 700;
  color: #2a2a2a;
  max-width: 492px;
  margin: 8px 0px 10px;
  line-height: 15.41px;
  text-align: center;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .redeem-steps-wrapper .redeem-step-bottom .redeem-step-bottom-text {
    margin-top: 0;
  }
}
.redeem-page-wrapper .apia-background-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}
.redeem-page-wrapper {
  /*************
  View 2 welcome message
  **************/
}
.redeem-page-wrapper .view2-welcome-wrapper {
  background-color: #008c80;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  padding: 30px;
  text-align: center;
}
.redeem-page-wrapper .view2-welcome-wrapper .view2-welcome-text {
  font-size: 50px;
  line-height: 1.2;
}
.redeem-page-wrapper .view2-welcome-wrapper .view2-welcome-text-highlight {
  line-height: 1.2;
  font-size: 50px;
  font-weight: bold;
}
.redeem-page-wrapper .view2-welcome-wrapper .view2-welcome-subtext {
  font-size: 25px;
  text-align: center;
  max-width: 690px;
  margin-top: 10px;
  width: 100%;
}
.redeem-page-wrapper .form-wrapper {
  background-color: #f5f5f5;
  padding-top: 35px;
  padding-bottom: 40px;
  height: auto;
  overflow: hidden;
}
.redeem-page-wrapper .form-wrapper .form-title {
  font-weight: 850;
  font-size: 32px;
  line-height: 38.39px;
  text-align: center;
}
.redeem-page-wrapper .form-wrapper .form-subtitle {
  font-weight: 400;
  font-size: 16px;
  line-height: 21.79px;
  text-align: center;
  padding-top: 59px;
  padding-bottom: 28px;
}
@media (max-width: 767px) {
  .redeem-page-wrapper .form-wrapper .form-subtitle {
    padding-top: 20px;
    padding-bottom: 25px;
  }
}
.redeem-page-wrapper .form-wrapper .view2-form-title {
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
}
.redeem-page-wrapper .form-wrapper .view2-form-subtitle {
  text-align: center;
  max-width: 700px;
  margin: 20px auto;
}
.redeem-page-wrapper .form-wrapper .form-container {
  max-width: 400px;
  margin: 0 auto;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiTextField-root {
  margin-bottom: 16px !important;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiOutlinedInput-root {
  border: 1px solid #c2c2c2;
  background: #fff;
  border-radius: 2px;
  font-size: 16px;
  color: #c2c2c2;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiOutlinedInput-root::placeholder {
  font-size: 16px;
  color: #c2c2c2;
}
.redeem-page-wrapper .form-wrapper .form-container .text_field_black.mb-2 {
  margin-bottom: 1.5rem !important;
}
.redeem-page-wrapper .form-wrapper .form-container .text_field_black .MuiInputLabel-formControl {
  font-size: 16px !important;
  font-weight: bold;
  color: #8f8f8f !important;
  width: 384px !important;
  padding: 4px 0 0;
}
.redeem-page-wrapper .form-wrapper .form-container .text_field_black .MuiInputBase-input {
  font-size: 16px !important;
  color: #c2c2c2 !important;
  width: 384px !important;
  padding: 12px 8px !important;
  font-weight: bold;
}
.redeem-page-wrapper .form-wrapper .form-container .text_field_black .MuiOutlinedInput-notchedOutline {
  top: -4px !important;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiInput-underline::before {
  border-bottom: 1px solid #c2c2c2 !important;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiInput-underline::after {
  border-bottom: 2px solid #c2c2c2 !important;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiInput-underline.Mui-error::before {
  border-bottom: 1px solid rgb(255, 83, 83) !important;
}
.redeem-page-wrapper .form-wrapper .form-container .MuiInput-underline.Mui-error::after {
  border-bottom: 2px solid rgb(255, 83, 83) !important;
}
.redeem-page-wrapper .form-wrapper .form-container .recaptcha {
  padding: 0 0 30px;
  text-align: center;
}
.redeem-page-wrapper .form-wrapper .form-container .recaptcha > * {
  display: inline-block;
}
.redeem-page-wrapper .form-wrapper .form-container .btn-action {
  display: flex;
  justify-content: center;
}
.redeem-page-wrapper .form-wrapper .form-container .btn-action .btn-submit-aami {
  font-size: 1rem !important;
  font-weight: 500;
  color: white !important;
  background: #668000 !important;
  border-radius: 8px !important;
  width: 400px;
  border: 2px solid #668000 !important;
  box-shadow: 0px 0px 7px #999999;
}
.redeem-page-wrapper .form-wrapper .form-container .btn-action .btn-submit-gio {
  font-size: 1rem !important;
  font-weight: 500;
  color: white !important;
  background: #ED1B2E !important;
  border: 2px solid #ED1B2E !important;
  border-radius: 8px !important;
  width: 400px;
  box-shadow: 0px 0px 7px #999999;
}
.redeem-page-wrapper .view2-footer-wrapper {
  background-color: #f5f5f5;
  display: flex;
  padding: 20px;
  justify-content: center;
}
.redeem-page-wrapper .view2-footer-wrapper .view2-footer-text {
  margin-top: 20px;
  max-width: 960px;
}
.redeem-page-wrapper .view2-footer-wrapper .view2-footer-text .text-blue {
  font-weight: 400;
  font-size: 16px;
  line-height: 15.41px;
  color: #005296;
  text-decoration: underline;
}

/*************
  CSS CLASSES
**************/
.mx-auto {
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
  padding: 0 30px;
}
@media (max-width: 640px) {
  .mx-auto {
    padding: 0 20px;
  }
}

/* Custom form controls */
.custom-form-control {
  margin-bottom: 20px;
}
.custom-form-control--error .custom-label {
  color: #ff5353;
}
.custom-form-control--error .custom-input {
  border-color: #ff5353;
}
.custom-label {
  display: block;
  font-size: 18px;
  margin-bottom: 6px;
}
@media only screen and (min-width: 768px) {
  .custom-label {
    font-size: 23px;
  }
}
.custom-input {
  width: 100%;
  height: 48px;
  border-radius: 5px;
  border: 1px solid #858585;
  font-size: 16px;
  padding: 12px;
}
@media only screen and (min-width: 768px) {
  .custom-input {
    font-size: 20px;
    height: 48px;
  }
}
.custom-btn-holder {
  text-align: center;
}
.custom-btn-holder input[type=submit] {
  background-color: #668000;
  color: #fff;
  border-radius: 43px;
  border: 0;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  min-width: 280px;
  padding: 10px 25px;
  cursor: pointer;
  margin-top: 20px;
}
@media only screen and (min-width: 768px) {
  .custom-btn-holder input[type=submit] {
    font-size: 23px;
    min-width: 389px;
  }
}
.custom-btn-holder input[type=submit]:hover {
  background-color: rgb(93.8039215686%, 67.2941176471%, 2.0392156863%);
}

.meta-form-info {
  color: #202020;
  display: block;
  margin: 24px 0;
  text-align: center;
}
@media only screen and (min-width: 768px) {
  .meta-form-info {
    margin: 50px -160px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/finalStep/customRedeem.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,iBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAEJ;AADI;EACE,YAAA;EACA,eAAA;AAGN;AAFM;EAHF;IAII,YAAA;EAKN;AACF;AAHI;EAbF;IAcI,iBAAA;IACA,oBAAA;IACA,uBAAA;EAMJ;AACF;AAHE;EACE,cAAA;AAKJ;AADI;EACE,yBAAA;EACA,WAAA;AAGN;AAEI;EACE,yBAAA;EACA,YAAA;AAAN;AAIE;EACE,yBAAA;AAFJ;AAII;EACE,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFN;AAGM;EATF;IAUI,sBAAA;IACA,8BAAA;IACA,iBAAA;IACA,oBAAA;EAAN;AACF;AAGI;EAGE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAHN;AAIM;EAXF;IAYI,oBAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EADN;AACF;AAKM;EADF;IAEI,kBAAA;IACA,cAAA;EAFN;AACF;AAIQ;EADF;IAEI,YAAA;EADR;AACF;AAvFA;EA6FE;;gBAAA;AADF;AAKE;EACE,iBAAA;EACA,oBAAA;AAHJ;AAII;EAHF;IAII,iBAAA;EADJ;AACF;AAGI;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EAEA,8BAAA;EACA,cAAA;AAHN;AAIM;EANF;IAOI,sBAAA;EADN;AACF;AAPI;EAUE,wBAAA;AAAN;AACM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AACR;AAAQ;EAPF;IAQI,WAAA;IACA,eAAA;EAGR;AACF;AAFQ;EACE,kBAAA;EACA,mBAAA;AAIV;AAHU;EAHF;IAII,mBAAA;EAMV;AACF;AALU;EACE,cAAA;AAOZ;AAFU;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIZ;AAEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAEM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;AAAR;AACQ;EARF;IASI,aAAA;EAER;AACF;AAGE;EACE,oEAAA;AADJ;AApLA;EAwLE;;gBAAA;AACF;AAEE;EAEE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AADN;AAII;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,WAAA;AAHN;AAOE;EACE,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AALJ;AAMI;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAJN;AAOI;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AALN;AAMM;EAPF;IAQI,iBAAA;IACA,oBAAA;EAHN;AACF;AAMI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAJN;AAOI;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AALN;AAQI;EACE,gBAAA;EACA,cAAA;AANN;AAOM;EACE,8BAAA;AALR;AAOM;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AALR;AAMQ;EACE,eAAA;EACA,cAAA;AAJV;AAQQ;EACE,gCAAA;AANV;AAQQ;EACE,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;AANV;AAQQ;EACE,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;AANV;AAQQ;EACE,oBAAA;AANV;AAUM;EACE,2CAAA;AARR;AAWM;EAEE,2CAAA;AAVR;AAaM;EACE,oDAAA;AAXR;AAcM;EACE,oDAAA;AAZR;AAeM;EACE,iBAAA;EACA,kBAAA;AAbR;AAcQ;EACE,qBAAA;AAZV;AAgBM;EACE,aAAA;EACA,uBAAA;AAdR;AAeQ;EACE,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,oCAAA;EACA,+BAAA;AAbV;AAeQ;EACE,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,YAAA;EAEA,+BAAA;AAdV;AAqBE;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAnBJ;AAqBI;EACE,gBAAA;EACA,gBAAA;AAnBN;AAoBM;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,0BAAA;AAlBR;;AAwBA;;cAAA;AAGA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AArBF;AAsBE;EALF;IAMI,eAAA;EAnBF;AACF;;AAsBA,yBAAA;AAEE;EACE,mBAAA;AApBJ;AAuBM;EACE,cAAA;AArBR;AAwBM;EACE,qBAAA;AAtBR;AA2BE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAzBJ;AA2BI;EALF;IAMI,eAAA;EAxBJ;AACF;AA2BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AAzBJ;AA2BI;EARF;IASI,eAAA;IACA,YAAA;EAxBJ;AACF;AA2BE;EACE,kBAAA;AAzBJ;AA2BI;EAEE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA1BN;AA4BM;EAdF;IAeI,eAAA;IACA,gBAAA;EAzBN;AACF;AA2BM;EACE,oEAAA;AAzBR;;AA+BA;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AA5BF;AA8BE;EANF;IAOI,mBAAA;EA3BF;AACF","sourcesContent":[".redeem-page-wrapper {\n  background-color: #ffffff;\n  min-height: 100vh;\n  .redeem-header {\n    display: flex;\n    flex-direction: row;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    align-items: center;\n    img {\n      width: 300px;\n      max-width: 100%;\n      @media (max-width: 767px) {\n        width: 225px;\n      }\n    }\n    @media (max-width: 767px) {\n      padding-top: 12px;\n      padding-bottom: 12px;\n      justify-content: center;\n    }\n  }\n\n  .apia-text-color {\n    color: #00369c;\n  }\n\n  .apia-button-color {\n    input[type=\"submit\"] {\n      background-color: #00837c;\n      color: #fff;\n    }\n  }\n\n  .suncorp-button-color {\n    input[type=\"submit\"] {\n      background-color: #fab919;\n      color: black;\n    }\n  }\n\n  .greeting-message {\n    background-color: #f5f5f5;\n\n    .greeting-message-content {\n      background-image: url(\"../../../assets/images/banner-bg.png\");\n      background-repeat: no-repeat;\n      background-position: 0 50%;\n      padding-top: 37px;\n      padding-bottom: 40px;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      @media (max-width: 767px) {\n        background-image: none;\n        flex-direction: column-reverse;\n        padding-top: 18px;\n        padding-bottom: 25px;\n      }\n    }\n\n    .greeting-message-text {\n      //font-size: clamp(1.5rem, 3.5vw, 2.8rem);\n      // font-family: \"Neuzeit S LT Std\", \"Sans-serif\";\n      font-size: 2.8rem;\n      line-height: 1.5;\n      font-weight: 700;\n      line-height: 54.28px;\n      color: #2a2a2a;\n      width: 60%;\n      max-width: 640px;\n      padding: 30px 0;\n      @media (max-width: 767px) {\n        padding: 13px 0 30px;\n        font-size: 2rem;\n        line-height: 1.2;\n        width: 100%;\n      }\n    }\n\n    .greeting-message-image {\n      @media (max-width: 767px) {\n        text-align: center;\n        margin: 0 auto;\n      }\n      img {\n        @media (max-width: 767px) {\n          width: 210px;\n        }\n      }\n    }\n  }\n\n  /*************\n  REDEEM STEPS\n  **************/\n\n  .redeem-steps-wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    @media (max-width: 767px) {\n      padding-top: 34px;\n    }\n\n    .redeem-step-text {\n      display: flex;\n      font-size: 2rem;\n      color: #cc0000;\n      justify-content: center;\n      align-items: center;\n      font-weight: 650;\n      margin-bottom: 29px;\n      text-align: center;\n    }\n\n    .redeem-steps {\n      display: flex;\n      flex-direction: row;\n      //gap: 2rem;\n      justify-content: space-between;\n      padding: 0 8px;\n      @media (max-width: 767px) {\n        flex-direction: column;\n      }\n\n      /** redeem step count **/\n      .redeem-steps-count {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        max-width: 280px;\n        padding: 0 16px 32px;\n        text-align: center;\n        @media (max-width: 767px) {\n          width: 100%;\n          max-width: none;\n        }\n        .redeem-circle {\n          text-align: center;\n          margin-bottom: 24px;\n          @media (max-width: 767px) {\n            margin-bottom: 17px;\n          }\n          img {\n            margin: 0 auto;\n          }\n        }\n\n        .redeem-circle-text {\n          p {\n            text-align: center;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 22px;\n            color: #2a2a2a;\n          }\n        }\n      }\n    }\n\n    .redeem-step-bottom {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .redeem-step-bottom-text {\n        font-size: 11.32px;\n        font-weight: 700;\n        color: #2a2a2a;\n        max-width: 492px;\n        margin: 8px 0px 10px;\n        line-height: 15.41px;\n        text-align: center;\n        @media (max-width: 767px) {\n          margin-top: 0;\n        }\n      }\n    }\n  }\n\n  .apia-background-image {\n    background-image: url(\"../../../assets/images/apia_background.png\") !important;\n  }\n\n  /*************\n  View 2 welcome message\n  **************/\n  .view2-welcome-wrapper {\n    // background-image: url(\"../../../assets/images/apia_background.png\");\n    background-color: #008c80;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    color: #ffffff;\n    padding: 30px;\n    text-align: center;\n\n    .view2-welcome-text {\n      font-size: 50px;\n      line-height: 1.2;\n    }\n    .view2-welcome-text-highlight {\n      line-height: 1.2;\n      font-size: 50px;\n      font-weight: bold;\n    }\n\n    .view2-welcome-subtext {\n      font-size: 25px;\n      text-align: center;\n      max-width: 690px;\n      // width: 540px;\n      margin-top: 10px;\n      width: 100%;\n    }\n  }\n\n  .form-wrapper {\n    background-color: #f5f5f5;\n    padding-top: 35px;\n    padding-bottom: 40px;\n    height: auto;\n    overflow: hidden;\n    .form-title {\n      font-weight: 850;\n      font-size: 32px;\n      line-height: 38.39px;\n      text-align: center;\n    }\n\n    .form-subtitle {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 21.79px;\n      text-align: center;\n      padding-top: 59px;\n      padding-bottom: 28px;\n      @media (max-width: 767px) {\n        padding-top: 20px;\n        padding-bottom: 25px;\n      }\n    }\n\n    .view2-form-title {\n      text-align: center;\n      max-width: 700px;\n      margin: 0 auto;\n    }\n\n    .view2-form-subtitle {\n      text-align: center;\n      max-width: 700px;\n      margin: 20px auto;\n    }\n\n    .form-container {\n      max-width: 400px;\n      margin: 0 auto;\n      .MuiTextField-root {\n        margin-bottom: 16px !important;\n      }\n      .MuiOutlinedInput-root {\n        border: 1px solid #c2c2c2;\n        background: #fff;\n        border-radius: 2px;\n        font-size: 16px;\n        color: #c2c2c2;\n        &::placeholder {\n          font-size: 16px;\n          color: #c2c2c2;\n        }\n      }\n      .text_field_black {\n        &.mb-2 {\n          margin-bottom: 1.5rem !important;\n        }\n        .MuiInputLabel-formControl {\n          font-size: 16px !important;\n          font-weight: bold;\n          color: #8f8f8f !important;\n          width: 384px !important;\n          padding: 4px 0 0;\n        }\n        .MuiInputBase-input {\n          font-size: 16px !important;\n          color: #c2c2c2 !important;\n          width: 384px !important;\n          padding: 12px 8px !important;\n          font-weight: bold;\n        }\n        .MuiOutlinedInput-notchedOutline {\n          top: -4px !important;\n        }\n      }\n\n      .MuiInput-underline::before {\n        border-bottom: 1px solid #c2c2c2 !important;\n      }\n\n      .MuiInput-underline::after {\n        // border-bottom: 2px solid white !important;\n        border-bottom: 2px solid #c2c2c2 !important;\n      }\n\n      .MuiInput-underline.Mui-error::before {\n        border-bottom: 1px solid rgb(255, 83, 83) !important;\n      }\n\n      .MuiInput-underline.Mui-error::after {\n        border-bottom: 2px solid rgb(255, 83, 83) !important;\n      }\n\n      .recaptcha {\n        padding: 0 0 30px;\n        text-align: center;\n        > * {\n          display: inline-block;\n        }\n      }\n\n      .btn-action {\n        display: flex;\n        justify-content: center;\n        .btn-submit-aami {\n          font-size: 1rem !important;\n          font-weight: 500;\n          color: white !important;\n          background: #668000 !important;\n          border-radius: 8px !important;\n          width: 400px;\n          border: 2px solid #668000 !important;\n          box-shadow: 0px 0px 7px #999999;\n        }\n        .btn-submit-gio {\n          font-size: 1rem !important;\n          font-weight: 500;\n          color: white !important;\n          background:#ED1B2E !important;\n          border: 2px solid #ED1B2E!important;\n          border-radius: 8px !important;\n          width: 400px;\n          // border: 2px solid #668000 !important;\n          box-shadow: 0px 0px 7px #999999;\n        }\n\n      }\n    }\n  }\n\n  .view2-footer-wrapper {\n    background-color: #f5f5f5;\n    display: flex;\n    padding: 20px;\n    justify-content: center;\n    // text-align: center;\n    .view2-footer-text {\n      margin-top: 20px;\n      max-width: 960px;\n      .text-blue {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 15.41px;\n        color: #005296;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n/*************\n  CSS CLASSES\n**************/\n.mx-auto {\n  width: 100%;\n  max-width: 1040px;\n  margin: 0 auto;\n  padding: 0 30px;\n  @media (max-width: 640px) {\n    padding: 0 20px;\n  }\n}\n\n/* Custom form controls */\n.custom {\n  &-form-control {\n    margin-bottom: 20px;\n\n    &--error {\n      .custom-label {\n        color: #ff5353;\n      }\n\n      .custom-input {\n        border-color: #ff5353;\n      }\n    }\n  }\n\n  &-label {\n    display: block;\n    font-size: 18px;\n    margin-bottom: 6px;\n\n    @media only screen and (min-width: 768px) {\n      font-size: 23px;\n    }\n  }\n\n  &-input {\n    width: 100%;\n    height: 48px;\n    border-radius: 5px;\n    border: 1px solid #858585;\n    font-size: 16px;\n    padding: 12px;\n\n    @media only screen and (min-width: 768px) {\n      font-size: 20px;\n      height: 48px;\n    }\n  }\n\n  &-btn-holder {\n    text-align: center;\n\n    input[type=\"submit\"] {\n      // background-color: #fab919;\n      background-color: #668000;\n      color: #fff;\n      border-radius: 43px;\n      border: 0;\n      font-size: 18px;\n      font-weight: bold;\n      text-align: center;\n      min-width: 280px;\n      padding: 10px 25px;\n      cursor: pointer;\n      margin-top: 20px;\n\n      @media only screen and (min-width: 768px) {\n        font-size: 23px;\n        min-width: 389px;\n      }\n\n      &:hover {\n        background-color: darken(#fab919, 6%);\n      }\n    }\n  }\n}\n\n.meta-form-info {\n  color: #202020;\n  display: block;\n  margin: 24px 0;\n  text-align: center;\n\n  @media only screen and (min-width: 768px) {\n    margin: 50px -160px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
